import _ from 'lodash'
import { FETCH_CARRIER_METHODS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_CARRIER_METHODS:
      return action.payload
    default:
      return state
  }
}
